



































import { Component, Vue } from "vue-property-decorator";
import SolicitacaoModel from "@/models/Solicitacao";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import SolicitacoesList, { SolicitacaoComParte } from "@/components/SolicitacoesList.vue";
import ProcessosList from "@/components/ProcessosList.vue";
import ProcessoModel, { ProcessoDados, ProcessoUsuariosRef } from "@/models/Processo";
import _debug from "debug";

const debug = _debug("Mediacao:components:HomeParte.vue");

const userModule = getModule(UserModule, store);

@Component({
    components: { SolicitacoesList, ProcessosList },
})
export default class HomeParte extends Vue {
    public carregandoSolicitacoes = true;
    private filtroMediacao: string[] = ["concluida", "aberta"];
    private solicitacoes: SolicitacaoModel[] = [];
    private solicitacoesFiltradas: SolicitacaoModel[] = [];
    private processos: ProcessoModel[] = [];

    public filtraSolicitacoes() {
        const filtro = this.filtroMediacao;
        const filtered = this.solicitacoes.filter(mediacao => {
            return filtro.includes(mediacao.status);
        });
        debug("Filtered solicitacoes", filtered);
        this.solicitacoesFiltradas.splice(0);
        Array.prototype.push.apply(this.solicitacoesFiltradas, filtered);
    }

    public adicionarSolicitacao() {
        debug("adicionando...");
        this.$router.push("/solicitacao/nova");
    }

    public editarSolicitacao(solicitacao: SolicitacaoModel) {
        this.$router.push(`/solicitacao/${solicitacao.id}`);
    }

    public visualizarProcesso(processo: ProcessoModel) {
        debug("visualizarProcesso:", processo);
        this.$router.push(`/processo/${processo.id}/`);
    }

    private created() {
        this.fetchSolicitacoes();
        this.fetchProcessos();
    }

    private async fetchSolicitacoes() {
        const user = userModule.getUser.userDb;
        if (user && user.email) {
            const solicitacoesDoUsuario = await SolicitacaoModel.listByUser(user.email);
            Array.prototype.push.apply(this.solicitacoes, solicitacoesDoUsuario);
            debug("carregou as solicitações!", this.solicitacoes, solicitacoesDoUsuario);
            debug("olhando as filtradas", this.solicitacoesFiltradas);
            this.carregandoSolicitacoes = false;
        }
    }

    private async fetchProcessos() {
        const user = userModule.getUser.userDb;
        if (user && user.email) {
            const meusProcessos = await ProcessoModel.listByUser(user.email);
            meusProcessos.forEach(processo => {
                if (
                    !this.processos.some(processoExisente => {
                        return processoExisente.id === processo.id;
                    })
                ) {
                    this.processos.push(processo);
                }
            });
        }
    }
}
